import axios from 'axios'
import { buildURL } from '../helper'
import apiConfig from '../../config/apiConfig'
import { getBpIdParam } from '../../common/helper'

const getFeedbackSurveyResponse = async (surveyId: string) => {
  const bpIdParam = getBpIdParam('secondParam')
  const surveyIdParam = surveyId ? `?survey_id=${surveyId}` : ''
  const { data } = await axios.get(
    `${buildURL('feedbackSurveyResponse', apiConfig.feedback)}${surveyIdParam}${bpIdParam}`,
  )
  return data
}

export default getFeedbackSurveyResponse
